import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

const UnfulfilledOrderLine = ({ payload, order, incompleteOrders }) => {
  return(
    <>
      <div className="has-hover sku-line flex-container">
        <div className="flex-4">
          <h4>
            Order #{order.id}
          </h4>
          { order.shippingPerson &&
            <span className="text-default warning">Shipment: {order.items.length} items shipping to {order.shippingPerson.city} {order.shippingPerson.state}, {order.shippingPerson.countryName}</span>
          }
            
          { !order.shippingPerson &&
            <span className="text-small muted">No shipments found</span>
          }
          <br/>
          <span className="text-default info">Ordered at: {order.createDate}</span>
        </div>

        <div className="flex-1">
          { order.shippingPerson &&            
            <Link to={`/purchase_order/dropship/${order.id}`}>
              <button className="btn btn-default">
                <span className="svg-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9"><path d="M5 4V2.5a.5.5 0 1 0-1 0V4H2.5a.5.5 0 1 0 0 1H4v1.5a.5.5 0 1 0 1 0V5h1.5a.5.5 0 1 0 0-1H5z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1H1v7h7V1zM1 0C.4477 0 0 .4477 0 1v7c0 .5523.4477 1 1 1h7c.5523 0 1-.4477 1-1V1c0-.5523-.4477-1-1-1H1z"/></svg>
                </span>
                <span className="gwt-InlineLabel">Create Purchase Order</span>
              </button>
            </Link>
          }
        </div>
      </div>
      <hr/>
    </>
  )
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(UnfulfilledOrderLine);
